import {
  Disclosure,
  DisclosureButton,
  DisclosurePanel,
} from "@headlessui/react";
import {
  HomeIcon,
  CurrencyDollarIcon,
  ArrowPathIcon,
  UserIcon,
  ChevronUpIcon,
} from "@heroicons/react/24/outline";
import { InviteFriends, AlertLimitDate, AlertCreditDefault, AlertQuotaAvailable, AlertPaymentReminder, RewardAvailable } from "./CallToActionUser";
function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export function NavbarUser(props) {
  const navigation = [
    {
      name: "Mis créditos",
      href: "/micredito",
      icon: HomeIcon,
      current: props.current === "1" ? true : false,
    },
    {
      name: "Pagar mi cuota",
      href: "/pagar",
      icon: CurrencyDollarIcon,
      current: props.current === "2" ? true : false,
    },
    {
      name: "Consultar cupo",
      href: "/renovar",
      icon: ArrowPathIcon,
      current: props.current === "3" ? true : false,
    },
    {
      name: "Perfil",
      href: "/perfil",
      icon: UserIcon,
      current: props.current === "4" ? true : false,
    },
  ];

  return (
    <>
      <aside className="hidden md:block md:px-6 w-32 lg:w-80 xl:w-60 2xl:w-80">
        <div className="px-4 grid content-between h-full pb-6 pt-8 bg-darkBg text-white rounded-xl">
          <div className="grid justify-items-center lg:block">
            <a href="/">
              <img
                className="h-12 w-auto"
                src="/svg/imagotipo-galilea-20.svg"
                alt="Galilea"
              />
            </a>
          </div>
          <nav aria-label="Sidebar">
            <div className="space-y-8 grid lg:block ">
              {navigation.map((item) => (
                <a
                  key={item.name}
                  href={item.href}
                  className={classNames(
                    item.current
                      ? "relative border-white text-white font-bold underline-offset-auto h-6"
                      : "text-grayP border-transparent",
                    "group flex items-center text-md"
                  )}
                >
                  <item.icon
                    className={classNames(
                      item.current ? "text-white" : "text-grayP",
                      "lg:mr-3 h-6 w-6"
                    )}
                    aria-hidden="true"
                  />
                  <div
                    className={classNames(
                      item.current
                        ? "absolute -bottom-2 text-white h-3 w-6 rounded-bl-full rounded-br-full rounded-b-full border-b-2 border-r-2 border-l-2"
                        : "hidden"
                    )}
                  ></div>
                  <div className="hidden lg:block">{item.name}</div>
                </a>
              ))}
            </div>
          </nav>
          <div className="hidden md:block h-full text-base bg-darkBgLight md:bg-transparent lg:bg-darkBgLight rounded-2xl">
            {
              props.disclosures?.showInviteFriends && (
                <InviteFriends />
              )
            }
            {
              props.disclosures?.showPaymentReminder && (
                <AlertPaymentReminder creditInfo={props?.creditInfo} due={props?.due} />
              )
            }
            {
              props.disclosures?.showAlertPaymentCreditToday && (
                <AlertLimitDate creditInfo={props?.creditInfo} />
              )
            }
            {
              props.disclosures?.showAlertCreditDefault && (
                <AlertCreditDefault creditInfo={props?.creditInfo} due={props?.due} />
              )
            }
            {
              props.disclosures?.showAlertQuotaAvailable && (
                <AlertQuotaAvailable />
              )
            }
            {
              props.disclosures?.showAlertRewardAvailable && (
                <RewardAvailable />
              )
            }
          </div>
        </div>
      </aside>

      {/* Menu mobile */}

      <aside className="block md:hidden fixed bottom-0 w-full max-w-full z-30">
        <div className="w-full bg-darkBg rounded-t-3xl pt-1">
          <Disclosure
            as="div"
            defaultOpen={props.current === "1" ? true : false}
            transition={"true"}
            className="origin-top transition duration-200 ease-out data-closed:-translate-y-6 data-closed:opacity-0"
          >
            <DisclosureButton className="group w-full grid justify-center pb-1">
              <ChevronUpIcon className="w-6 h-auto text-grayP cursor-pointer group-data-open:rotate-180 duration-700" />
            </DisclosureButton>
            <DisclosurePanel
              transition={"true"}
              className="origin-top transition duration-200 ease-out data-closed:-translate-y-6 data-closed:opacity-0"
            >
              <div className=" flex gap-2 p-4 h-full text-base bg-darkBgLight rounded-2xl mx-4">
                {
                  props.disclosures?.showInviteFriends && (
                    <InviteFriends />
                  )
                }
                {
                  props.disclosures?.showPaymentReminder && (
                    <AlertPaymentReminder creditInfo={props?.creditInfo} due={props?.due} />
                  )
                }
                {
                  props.disclosures?.showAlertPaymentCreditToday && (
                    <AlertLimitDate creditInfo={props?.creditInfo} />
                  )
                }
                {
                  props.disclosures?.showAlertCreditDefault && (
                    <AlertCreditDefault creditInfo={props?.creditInfo} due={props?.due} />
                  )
                }
                {
                  props.disclosures?.showAlertQuotaAvailable && (
                    <AlertQuotaAvailable />
                  )
                }
                {
                  props.disclosures?.showAlertRewardAvailable && (
                    <RewardAvailable />
                  )
                }
              </div>
            </DisclosurePanel>
          </Disclosure>
          <div>
            <div className="flex justify-between pt-2 pb-8">
              {navigation.map((item) => (
                <a
                  key={item.name}
                  href={item.href}
                  className={classNames(
                    item.current
                      ? "relative border-white text-white font-bold underline-offset-auto h-6"
                      : "text-grayP border-transparent",
                    "group w-full items-center text-xs grid justify-items-center"
                  )}
                >
                  <item.icon
                    className={classNames(
                      item.current ? "text-white" : "text-grayP",
                      "lg:mr-3 h-6 w-6"
                    )}
                    aria-hidden="true"
                  />
                  <div
                    className={classNames(
                      item.current
                        ? "absolute -bottom-2 text-white h-3 w-6 rounded-bl-full rounded-br-full rounded-b-full border-b-2 border-r-2 border-l-2"
                        : "hidden"
                    )}
                  ></div>
                  <div className="block pt-2">{item.name}</div>
                </a>
              ))}
            </div>
          </div>
        </div>
      </aside>
    </>
  );
}
